import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 3
};
const _hoisted_5 = {
  key: 4
};
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { indexMethod } from '@/utils/indexMethod';
import { getUserApprovalList } from '@/api/user';
export default {
  __name: 'Table',
  props: {
    schemas: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    }
  },
  emits: ['del', 'data', 'update', 'info', 'approval', 'async'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleUpdate = row => {
      emits('update', row);
    };
    const handleDel = row => {
      emits('del', row);
    };
    const handleApproval = row => {
      emits('approval', row);
    };
    const handleInfo = row => {
      emits('info', row);
    };
    const handleAsync = row => {
      emits('async', row);
    };
    const approvalUserIdArr = ref([]);
    const getApprovalUser = async () => {
      const res = await getUserApprovalList({
        type: 2
      });
      approvalUserIdArr.value = res.records.map(item => item.auditorId);
    };
    onMounted(() => {
      getApprovalUser();
    });
    const store = useStore();
    // 是否显示审批按钮
    const isApprovalVisible = computed(() => {
      var _store$getters$userIn;
      return approvalUserIdArr.value.includes((_store$getters$userIn = store.getters.userInfo) === null || _store$getters$userIn === void 0 || (_store$getters$userIn = _store$getters$userIn.sysUser) === null || _store$getters$userIn === void 0 ? void 0 : _store$getters$userIn.id);
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.tableData,
        style: {
          "width": "100%"
        },
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.currentPage, __props.pageSize),
          align: "center",
          "min-width": 30
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schemas, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.label,
            "min-width": item.minWidth,
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'createTime' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$filters.dateFilter(row[item.prop])), 1)) : item.prop === 'applyStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_tag, {
              type: `${row[item.prop] == 1 ? 'success' : ''}`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row[item.prop] == 1 ? '使用中' : '停用'), 1)]),
              _: 2
            }, 1032, ["type"])])) : item.prop === 'approvalStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_tag, {
              type: `${row[item.prop] == 1 ? 'success' : ''}`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row[item.prop] == 1 ? '进行中' : row[item.prop] == 2 ? '审批完成' : '拒绝'), 1)]),
              _: 2
            }, 1032, ["type"])])) : item.prop === 'action' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.btnArr, (item, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: index
              }, [item === 'info' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                size: "small",
                onClick: $event => handleInfo(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'update' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [row.tenantId == 0 || row.approvalStatus === 2 || !row.approvalStatus ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: $event => handleUpdate(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), isApprovalVisible.value && row.tenantId != 0 && item === 'approval' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "warning",
                size: "small",
                onClick: $event => handleApproval(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 审批 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'delete' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "danger",
                size: "small",
                onClick: $event => handleDel(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'async' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                type: "success",
                size: "small",
                onClick: $event => handleAsync(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 线索配置 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(row[item.prop]), 1))]),
            _: 2
          }, 1032, ["label", "min-width"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]);
    };
  }
};